import { K8sProviderIcon } from '@cast/features-cluster-ui';

import { DialogTitle, Stack } from '@cast/design-system';
import { Cluster } from '@cast/types';

import { ClusterDialogHeaderActions } from 'hooks/dialogs/cluster/_components/ClusterDialogHeaderActions';
import { ClusterDialogTitle } from 'hooks/dialogs/cluster/_components/new-onboarding';

export type DialogHeaderProps = {
  cluster?: Cluster;
  onClose: () => void;
};

export const DialogHeader = ({ cluster, onClose }: DialogHeaderProps) => {
  return (
    <DialogTitle>
      <Stack
        direction="row"
        gap={4}
        alignItems="center"
        justifyContent="space-between"
        data-testid="install-kent-script-step-header"
      >
        <Stack direction="row" alignItems="center" gap={8} flexWrap="nowrap">
          {cluster && (
            <K8sProviderIcon provider={cluster?.providerType} size={24} />
          )}
          <ClusterDialogTitle>
            {cluster?.name || 'Connect your K8s cluster'}
          </ClusterDialogTitle>
        </Stack>

        <ClusterDialogHeaderActions onClose={onClose} />
      </Stack>
    </DialogTitle>
  );
};
